import { ConfigurationReference, readConfObject } from '@jbrowse/core/configuration';
import { getSession } from '@jbrowse/core/util';
import { BaseConnectionModelFactory } from '@jbrowse/core/pluggableElementTypes/models';
import { types } from 'mobx-state-tree';
import configSchema from './configSchema';
import { fetchJb1 } from './jb1ConfigLoad';
import { convertTrackConfig } from './jb1ToJb2';
export default function (pluginManager) {
  return types.compose('JBrowse1Connection', BaseConnectionModelFactory(pluginManager), types.model({
    configuration: ConfigurationReference(configSchema),
    type: types.literal('JBrowse1Connection')
  })).actions(function (self) {
    return {
      connect: function connect() {
        var dataDirLocation = readConfObject(self.configuration, 'dataDirLocation');
        var session = getSession(self);
        fetchJb1(dataDirLocation).then(function (config) {
          var _a;
          var assemblyName = readConfObject(self.configuration, 'assemblyNames')[0];
          if (!assemblyName) {
            throw new Error('assembly name required for JBrowse 1 connection');
          }
          var assemblyConf = session.assemblies.find(function (assembly) {
            return readConfObject(assembly, 'name') === assemblyName;
          });
          if (!assemblyConf) {
            throw new Error("Assembly \"".concat(assemblyName, "\" not found"));
          }
          var sequenceAdapter = readConfObject(assemblyConf, ['sequence', 'adapter']);
          // @ts-ignore
          var jb2Tracks = (_a = config.tracks) === null || _a === void 0 ? void 0 : _a.map(function (jb1Track) {
            var jb2Track = convertTrackConfig(jb1Track, config.dataRoot || '', sequenceAdapter);
            // @ts-ignore
            jb2Track.assemblyNames = [assemblyName];
            return jb2Track;
          });
          self.setTrackConfs(jb2Tracks);
        }).catch(function (error) {
          console.error(error);
          session.notify("There was a problem connecting to the JBrowse 1 data directory \"".concat(self.name, "\". Please make sure you have entered a valid location. The error that was thrown is: \"").concat(error, "\""), 'error');
          session.breakConnection(self.configuration);
        });
      }
    };
  });
}